import one_b from "../img/blogs/1billion.png";

const courses = [
    {
        id: 1,
        category: 'None',
        image: one_b,
        link1: '',
        link2: '',
        title: 'None',
        text: ''
    },
];

export default courses;
